import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WhatsappLogo, PaperPlaneTilt } from "@phosphor-icons/react";
import { CONTACTS, CONTENT } from "../../data/content";
import { useLang } from "../../context/LanguageContext";
import { scrollToId } from "../../lib/api";

export const FloatingCTA = () => {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waMsg = encodeURIComponent(
    lang === "it"
      ? "Ciao AppForge Studio! Vorrei informazioni su un progetto."
      : "Hi AppForge Studio! I'd like info about a project."
  );

  return (
    <div className="fixed bottom-6 right-6 z-[90] flex flex-col items-end gap-3">
      <AnimatePresence>
        {show && (
          <motion.button
            data-testid="floating-quote-btn"
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            onClick={() => scrollToId("contatti")}
            className="inline-flex items-center gap-2 rounded-full bg-white text-black font-semibold px-5 py-3 shadow-2xl shadow-black/50 hover:bg-blue-500 hover:text-white transition-colors"
          >
            <PaperPlaneTilt size={18} weight="fill" /> {CONTENT[lang].ctaQuote}
          </motion.button>
        )}
      </AnimatePresence>

      <motion.a
        data-testid="floating-whatsapp-btn"
        href={`https://wa.me/${CONTACTS.whatsapp}?text=${waMsg}`}
        target="_blank"
        rel="noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 200, delay: 0.5 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl shadow-[#25D366]/30"
        aria-label="WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <WhatsappLogo size={30} weight="fill" className="text-white relative" />
      </motion.a>
    </div>
  );
};
